import useWebChatAPIContext from '/druid/useWebChatAPIContext';

export default function useLocalizedGlobalize() {
  return useWebChatAPIContext().localizedGlobalizeState;
}
